import { render, staticRenderFns } from "./CopyOrderModal.vue?vue&type=template&id=4bac3cfa"
import script from "./CopyOrderModal.vue?vue&type=script&lang=ts"
export * from "./CopyOrderModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports